const SORT_ASCENDING = 'A';
export default SORT_ASCENDING;